import { JsonObject, JsonProperty } from 'json2typescript';
import { DateConverter } from './converters/date-converter';
import { Entity } from './entity';
import { Attachment } from './attachment';

interface MachineInfo {
  machineId: string;
  serialNumber: string;
}

@JsonObject('SalesOrder')
export class SalesOrder extends Entity {
  @JsonProperty('accountId', String)
  public accountId?: string = undefined;
  @JsonProperty('salesOrderNumber', String)
  public salesOrderNumber?: string = undefined;
  @JsonProperty('createdDate', DateConverter)
  public createdDate?: Date = undefined;
  @JsonProperty('attachment', Attachment)
  public attachment?: Attachment = undefined;
  @JsonProperty('attachmentId', String, true)
  public attachmentId?: string = undefined;

  public attachmentBody?: string = undefined;
  public attachmentFileName?: string = undefined;

  @JsonProperty('machineInfos', [Object])
  public machineInfos?: MachineInfo[] = undefined;

  @JsonProperty('accountName', String)
  public accountName?: string = undefined;

  public get reqDocName(): string | undefined {
    return this.salesOrderNumber;
  }
  public set reqDocName(value: string | undefined) {
    this.salesOrderNumber = value;
  }
}
